import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaFileAlt, FaList, FaBook  } from 'react-icons/fa';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import '../../Styles/Sidebar.css';
import { useSidebar } from '../SidebarContext';  // Use the context

import {getInitialData, getPresignedUrl} from '../../Home/Services/index';//DisplayMAnual.js

const Sidebar = ({ onLogout }) => {
  const { isConfigOpen, toggleConfig } = useSidebar();  // Use the context for isConfigOpen and toggleConfig

  const [user, setUser] = useState(null);
  const [hoveredItem, setHoveredItem] = useState(null);

  const navigate = useNavigate();

  const sidebarRef = useRef(null);  // Ref for the sidebar container
  const configBarRef = useRef(null);  // Ref for the config bar

  //DisplayManual.js
    const [solutionList, setSolutionList] = useState([]);
    const [solutionId, setSolutionId] = useState('');
    let solution;

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }

    // Function to handle mouse leave event
    const handleMouseLeave = (event) => {
      if (
        configBarRef.current &&
        !configBarRef.current.contains(event.target) &&
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target)
      ) {
        toggleConfig();  // Close the config bar if the mouse is outside both the sidebar and config bar
      }
    };

    // Add event listener for mouse move or mouse leave to close the config bar
    document.addEventListener('mousemove', handleMouseLeave);

    // Cleanup the event listener when the component unmounts
    return () => {
      document.removeEventListener('mousemove', handleMouseLeave);
    };
  }, [toggleConfig]);

  const handleNavigation = (path) => {
    navigate(path);
  };

  const handleSettingsNavigation = (path) => {
    navigate(path);
    toggleConfig();
  };

  const handleItemClick = (path) => {
    if (isConfigOpen) {
      toggleConfig(); // Close config bar if it's open
    }
    navigate(path); // Navigate to the respective page
  };

  const handleSidebarHover = () => {
    // Optionally, you can add any behavior when hovering over the sidebar
  };


  //displayManual.js
  useEffect(() => {
          loadInitialData()
  }, []);

  const loadInitialData = async () => {
      const result = await getInitialData(solutionId);
      if(result && result.status === 200) {
        await setSolutionList([...result.payLoad.solutions]);
      }
  }

  const handleSolutionChange = async (selectedSolution) => {
      if(selectedSolution != undefined){
          await loadPdf(selectedSolution);
      }    
  }

  //to toggle manual
  const handleManualNavigation = (path) => {
    toggleConfig();
  };

  //user manual
  const loadPdf = async (solutionName) => {
    const env = process.env.REACT_APP_ENV;
    let bucket;
    if(env === 'dev') bucket = 'dev-neviton-app-quote';
  
    else if(env === 'prod') bucket = 'prod-neviton-app-quote';
  
    let key;
    if(solutionName === "Greenfield AWS Landing Zone") {
      key = `assets/GreenFieldAWSLandingZoneImplementation&SupportQuoteGenerator1.pdf`;
    }
  
    else if(solutionName === "AWS Migration - Landing Zone to Control Tower"){
      key = `assets/AWSMigrationLandingZonetoControlTower-Implementation&SupportQuoteGenerator.pdf`;
    }

    else if(solutionName === "Greenfield Landing Zone - Out-of-Box Solution"){
      key = `assets/template/GreenFieldAWSOutOfBoxImplementation&SupportQuoteGenerator.pdf`;
    }
    
    const response = await getPresignedUrl(bucket, key);
    if (response && response.payLoad) {
      window.open(response.payLoad, '_blank'); 
    }
  }

  return (
    <div className="sidebar-container">
      <div
        className="sidebar"
        ref={sidebarRef}  // Attach ref to the sidebar
        onMouseEnter={handleSidebarHover}
      >
        <ul className="sidebar-items">
          <li className="sidebar-item" onMouseEnter={() => setHoveredItem('Quotes')} onMouseLeave={() => setHoveredItem(null)} onClick={() => handleItemClick('/home')}>
            <FaFileAlt className="icon" />
            <span className="item-label">Quotes</span>
          </li>

          <li className="sidebar-item" onMouseEnter={() => setHoveredItem('Quotes List')} onMouseLeave={() => setHoveredItem(null)} onClick={() => handleItemClick('/quotes')}>
            <FaList className="icon" />
            <span className="item-label">Quotes List</span>
          </li>

          {/* <li className="sidebar-item" onMouseEnter={() => setHoveredItem('Configuration')} onMouseLeave={() => setHoveredItem(null)} onClick={() => handleSettingsNavigation('/users')}>
            <FaCog className="icon" />
            <span className="item-label">Configuration</span>
          </li> */}

                                                                                                                              {/*changed from handleItemClick event to this  */}
          <li className="sidebar-item" onMouseEnter={() => setHoveredItem('Solution Guide')} onMouseLeave={() => setHoveredItem(null)} onClick={() => handleManualNavigation('/manual')}>
            <FaBook className="icon" />
            <span className="item-label">Solution Guide</span>
          </li>

          <li className="sidebar-item" onMouseEnter={() => setHoveredItem('Logout')} onMouseLeave={() => setHoveredItem(null)} onClick={onLogout}>
            <FontAwesomeIcon icon={faSignOutAlt} className="sidebar-icon" />
            <span className="item-label">Logout</span>
          </li>
        </ul>
      </div>

       {/* Display hovered item name outside the sidebar */}
        {/* Hovered item name displayed outside */}
        <div className={`sidebar-hovered-item 
          ${hoveredItem === 'Quotes' ? 'sidebar-hovered-quotes' : ''}
          ${hoveredItem === 'Quotes List' ? 'sidebar-hovered-quotes-list' : ''}
          ${hoveredItem === 'Configuration' ? 'sidebar-hovered-configuration' : ''}
          ${hoveredItem === 'Solution Guide' ? 'sidebar-hovered-solution-guide' : ''}
          ${hoveredItem === 'Logout' ? 'sidebar-hovered-logout' : ''}`}>
          {hoveredItem && <span>{hoveredItem}</span>}
        </div>

      {isConfigOpen===!isConfigOpen && ( 
        <div 
          className="config-bar"
          ref={configBarRef}  // Attach ref to the config bar
        >
          <ul className="config-items">
            <li className="config-item" onClick={() => handleNavigation('/usertypes')}>
              <span>User Type</span>
            </li>
            <li className="config-item" onClick={() => handleNavigation('/solution')}>
              <span>Solution</span>
            </li>
            <li className="config-item" onClick={() => handleNavigation('/questions')}>
              <span>Question</span>
            </li>
            <li className="config-item" onClick={() => handleNavigation('/options')}>
              <span>Option</span>
            </li>
            <li className="config-item" onClick={() => handleNavigation('/timeprice')}>
              <span>Time & Price</span>
            </li>
            <li className="config-item" onClick={() => handleNavigation('/bankdetails')}>
              <span>Bank Details</span>
            </li>
            <li className="config-item" onClick={() => handleNavigation('/users')}>
              <span>Users</span>
            </li>
            
          </ul>
        </div>
      )}

      {isConfigOpen && (
        <div className='manual' ref={configBarRef} >
        
          <ul className="config-items">
            {solutionList.slice(0,3).map((sol, index) => ( //retreives only the first 2 solutions
              <li
                className='config-item'
                key={sol.solutionName}
                onClick={() => handleSolutionChange(sol.solutionName)} // Set the selected solution when clicked
              >
                {index+1}. {sol.solutionName} {/*this will display numbered list */}
              </li>
            ))}
            </ul>

        </div>
      )}
    </div>
  );
};

export default Sidebar;